import { createFileRoute } from '@tanstack/react-router'

import { NotificationsSection } from '@/components/settings/organization/notifications-section'
import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { requirePermission, PermissionDeniedRoute } from '@/lib/require-permission-guard'

export const Route = createFileRoute('/_app/_settings/notifications')({
  component: NotificationsPage,
  beforeLoad: async ({ context }) => {
    await requirePermission(context.queryClient, 'SettingsManage', 'notification settings')
  },
  errorComponent: PermissionDeniedRoute,
})

function NotificationsPage() {
  useBreadcrumbFromRoute()

  return (
    <div className="flex flex-col gap-4 p-6">
      <NotificationsSection />
    </div>
  )
}
